export class ExportEmailForBriefingModel {
    userId?: any;
    email?: any;
    firstName?: any;
    lastName?: any;
    title?: any;
    updateDate?: any;
    companyName?: any;
    emailStatus?: any;
    failureReason?: any;
    failedAttempt?: any;
    totalRecordCount?:any;
}

export class BriefingEmailDataByBriefingIdModel {
    brifingId?: any;
    currentPage?: any;
    pageSize?: any;
    isExport?: any;
}